import { useState } from 'react';
import { Locker, LockerPluginOptions, PointLocation } from '../data/LockerDataTypes';
import { getLockerPluginOptions } from '../services/queryParams';
import type { ReactSetState } from '../utils/types';
import { ContextProviderProps, createContext } from '../common/contextFactory';

type LockersProps = {
    unfilteredLockerResponse: Locker[];
    setUnfilteredLockerResponse: ReactSetState<Locker[]>;
    lockerResponse: Locker[];
    setLockerResponse: ReactSetState<Locker[]>;
    geolocation: PointLocation;
    setGeolocation: ReactSetState<PointLocation>;
    lockerPluginOptions: LockerPluginOptions;
    setLockerPluginOptions: ReactSetState<LockerPluginOptions>;
    searchFilter: string;
    setSearchFilter: ReactSetState<string>;
}

const [useLockersContext, Provider] = createContext<LockersProps>('LockersCtx');

const useInitLockersContext = () => {
    const [lockerResponse, setLockerResponse] = useState<Locker[]>([] as Locker[]);
    const [unfilteredLockerResponse, setUnfilteredLockerResponse] = useState<Locker[]>([] as Locker[]);
    const [geolocation, setGeolocation] = useState<PointLocation>(null as unknown as PointLocation);
    const [lockerPluginOptions, setLockerPluginOptions] = useState<LockerPluginOptions>(getLockerPluginOptions());
    const [searchFilter, setSearchFilter] = useState<string>(null as any);

    const lockersProps: LockersProps = {
        unfilteredLockerResponse,
        setUnfilteredLockerResponse,
        lockerResponse,
        setLockerResponse,
        geolocation,
        setGeolocation,
        lockerPluginOptions,
        setLockerPluginOptions,
        searchFilter, 
        setSearchFilter
    };
    return lockersProps;
};

const LockersContextProvider = ({ children }: ContextProviderProps) => {
    return <Provider value={useInitLockersContext()}>
        {children}
    </Provider>;
};

export { useLockersContext, LockersContextProvider };
